import MoveTo from "moveto";
const moveTo = new MoveTo({
    tolerance: 50,
    duration: 400
});
const triggers = document.querySelectorAll('a[href^="#"]');;
for (var i = 0; i < triggers.length; i++) {
    moveTo.registerTrigger(triggers[i]);
}